module.exports = __webpack_public_path__ + "img/icon_ccf.3340a875.svg";